import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class BaseServiceService {

  constructor(private httpClient: HttpClient) { }
  protected http() {
    return this.httpClient;
  }
  public makeGetRequest(url: string, headers?: HttpHeaders, httpParams?: HttpParams): Observable<any> {
    const serverUrl = url;
    return this.httpClient.get(serverUrl, { headers, params: httpParams ? httpParams : undefined });
  }
  public makeGetRequestBOt(url: string, headers?: HttpHeaders, httpParams?: HttpParams): Observable<any> {
    const serverUrl = environment.hostUrl + url;
    return this.httpClient.get(serverUrl, { headers, params: httpParams ? httpParams : undefined });
  }

  public makePostRequest(url: string, body: unknown, headers?: HttpHeaders, httpParams?: HttpParams): Observable<any> {
    const serverUrl = environment.hostUrl + url;
    return this.httpClient.post(serverUrl, body, { headers, params: httpParams ? httpParams : undefined });
  }
  public makeLiveChatPostRequest(url: string, body: unknown, headers?: HttpHeaders, httpParams?: HttpParams): Observable<any> {
    const serverUrl =  url;
    return this.httpClient.post(serverUrl, body, { headers, params: httpParams ? httpParams : undefined });
  }
}
